import {ItemIconClass} from "./item-icon/icon/item-icon-class";

// import {ItemIcon} from "./item-icon/item-icon";

export enum ProjectAccess {
    READ_ONLY   = -10,
    // READ_ONLY_WITH_COMMENT= -9, // just reserve
    CLIENT      = -5,

    LIMITED     = 1,
    STANDARD    = 2,
    FULL        = 3
}

export const ProjectAccessLabelDictionary : any = {
    [ProjectAccess.FULL]               : 'Full',
    [ProjectAccess.STANDARD]           : 'Standard',
    [ProjectAccess.LIMITED]            : 'Limited',
    [ProjectAccess.CLIENT]             : 'Customer',
    [ProjectAccess.READ_ONLY]          : 'Read only',
}

export const ProjectAccessDescriptionDictionary : any = {
    [ProjectAccess.FULL]               : 'Access to all data and management options, suitable for managers.',
    [ProjectAccess.STANDARD]           : 'View all work items but no access to settings or user management.',
    [ProjectAccess.LIMITED]            : 'View only specific folders and tasks they’ve been added to.',
    [ProjectAccess.CLIENT]             : '',
    [ProjectAccess.READ_ONLY]          : 'View all projects and tasks without editing rights.',
}

export const WorkspaceAccessDescription: { [key: number]: string } = {
    [ProjectAccess.FULL]            : 'Can manage workspace settings, invite users, and create workspace views.',
    [ProjectAccess.STANDARD]        : 'Has access to workspace resources but cannot change settings or invite users.',
    [ProjectAccess.LIMITED]         : 'Access level not supported.',
    [ProjectAccess.CLIENT]          : 'Access level not supported.',
    [ProjectAccess.READ_ONLY]       : 'Access level not supported.',
}

export enum UserInheritance {
    MANUAL          = 0,
    INHERITED       = 1,
    UPHERITED       = 2,     // not in use ?
    INHERITED_TEAM  = 3,
}

export enum ProjectRole {
    CLIENT          = 1,
    GUEST           = 2,
    USER            = 3,
    PROJECT_MANAGER = 4,
    OWNER           = 5
}

// see const ItemIcon
// to add new - add to
// ProjectIconsOptionsList, - eto options
// a eche nado add to ii ?
export const ProjectIconDictionary : DictionaryStringString = ItemIconClass

export const ConstProject = {

    // this should be changed to systemType in future
    type: {
        PROJECT: 1,
        WORKFOLDER: 2,      // old
        FOLDER: 2,          // new
        BACKLOG: 3,
        SPRINT: 4,
        TAG: 5
    },

    systemType: {
        FOLDER: 2,          // project etc
        TAG: 5
    },

    typeList: {
        1: 'Project',
        2: 'Folder',
        3: 'Backlog',
        4: 'Sprint',
        5: 'Tag'
    },

    typeIcon: {
        1: 'ii5-project',
        2: 'ii5-folder',
        3: 'ii5-archive',
        4: 'ii5-sprint',
        5: 'ii5-tag'
    },

    access: {
        READ_ONLY: -10,
        // READ_ONLY_WITH_COMMENT: -9, // just reserve
        CLIENT: -5,

        LIMITED: 1,
        STANDARD: 2,
        FULL: 3
    },

    accessList: {
        1: 'Limited',
        2: 'Standard',
        3: 'Full'
    },

    role: {
        CLIENT: 1,
        GUEST: 2,
        USER: 3,
        PROJECT_MANAGER: 4,
        OWNER: 5
    },

    workfolderStatus: {
        OPEN: 2,
        CLOSED: 5
    },

    workfolderStatusList: {
        2: 'Open',
        5: 'Archived'
    },

    sprintStatus: {
        NOT_STARTED: 1,
        IN_PROGRESS: 2,
        IN_REVIEW: 3,
        COMPLETED: 5
    },

    sprintStatusList: {
        1: 'Planning',
        2: 'Active',
        3: 'Review',
        5: 'Closed'
    },

    // this is depricated ... used in analytics only for d3 charts



    color: {
        0: '858F93',
        1: 'E9536F',
        2: 'E9536F',
        3: 'B738A2',
        4: '735ABF',
        5: '735ABF',
        6: '28A9F0',
        7: '28A9F0',
        8: '28A9F0',
        9: '21AB9B',
        10: '41B45E',
        11: '41B45E',
        12: '41B45E',
        13: '21AB9B',
        14: 'F0B400',
        15: 'FF8F33',
        16: 'FC6F66',
        17: '858F93',
        18: '858F93',
        19: '956B56',
        20: '4E90E4',
        21: '4E90E4',
        22: '735ABF',
        23: '858F93',
        24: '735ABF',
        25: '858F93',
        26: 'E9536F'
    },

    // is it in use ???
    userInheritance: {
        MANUAL      : 0,
        INHERITED   : 1,
        UPHERITED   : 2
    },

    icon        : ProjectIconDictionary,

};
